import type { Edition } from '../types'

/**
 * Single source of truth for edition (translation) language display. Both
 * ReaderFloatingSettings and the now-deleted TranslationSelector carried
 * private copies of this table plus their own sort — one map + two helpers
 * ends that duplication.
 */
export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English', fr: 'French', ar: 'Arabic', es: 'Spanish', de: 'German',
  it: 'Italian', tr: 'Turkish', ur: 'Urdu', id: 'Indonesian', ms: 'Malay',
  ru: 'Russian', zh: 'Chinese', ja: 'Japanese', ko: 'Korean', nl: 'Dutch',
  pt: 'Portuguese', sv: 'Swedish', fa: 'Persian', bn: 'Bengali',
}

export function languageLabel(code: string): string {
  return LANGUAGE_NAMES[code] ?? code.toUpperCase()
}

// Sorts by language label then by edition englishName, so groups are
// clustered. Returns a new array — the input is never mutated.
export function sortEditions(editions: Edition[]): Edition[] {
  return [...editions].sort((a, b) => {
    const langA = languageLabel(a.language)
    const langB = languageLabel(b.language)
    if (langA !== langB) return langA.localeCompare(langB)
    return a.englishName.localeCompare(b.englishName)
  })
}
